// extracted by mini-css-extract-plugin
export default {"spinner-content":"IpaAdministrationWizard_spinner-content__xv1cA","spinner":"IpaAdministrationWizard_spinner__NNhYL"};